import Vue from 'vue'
import App from './App.vue'
import '@/assets/style.scss'
import VueTour from 'vue-tour'
import store from './store'

Vue.config.productionTip = false

require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
